import { render } from "./D3ForceGraph.vue?vue&type=template&id=24bffe57&scoped=true"
import script from "./D3ForceGraph.vue?vue&type=script&lang=js"
export * from "./D3ForceGraph.vue?vue&type=script&lang=js"

import "./D3ForceGraph.vue?vue&type=style&index=0&id=24bffe57&scoped=true&lang=css"
import "./D3ForceGraph.vue?vue&type=style&index=1&id=24bffe57&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bffe57"]])

export default __exports__